import {Component, Injector, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ClaimService} from "../../../../services/claim.service";
import {Claim} from "../../../../model/claim.model";
import {ClaimsBaseComponent} from "../../../claim-base.component";
import {DatePipe} from "@angular/common";
import {DocumentField} from '../../../../model/document-field';
import {ClaimTypes} from '../../../../model/claim-type.model';
import {DocumentHelperService} from "../../../../services/document-helper.service";
import { DeathAndPermanentDisability } from 'src/app/model/domestic-helper/death-and-permanent-disability.model';

@Component({
    selector: 'app-summary-death-and-permanent-disability',
    templateUrl: './summary-death-and-permanent-disability.component.html',
    styleUrls: ['./summary-death-and-permanent-disability.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SummaryDeathAndPermanentDisabilityComponent extends ClaimsBaseComponent implements OnInit {

    claim: Claim;
    deathAndPermanentDisability: DeathAndPermanentDisability;
    listOfDocuments: DocumentField[] = [];

    constructor(private claimService: ClaimService,
                private documentHelperService: DocumentHelperService,
                private injector : Injector) {

        super(injector);
        this.claim = this.claimService.getClaim();
        this.deathAndPermanentDisability = this.claim.getClaimDomesticHelper().getDeathAndPermanentDisability();
        this.listOfDocuments = this.documentHelperService.getListOfDocuments(this.claimService.claim.getDocumentForm().documents,
            this.documentHelperService.getDocumentFormBuilder(ClaimTypes[ClaimTypes.CLAIM_TYPE_DMH_DEATH]).getRequiredDocuments(),
            ClaimTypes[ClaimTypes.CLAIM_TYPE_DMH_DEATH]);
    }
    
    ngOnInit() { }

    returnYesOrNo(value: string) {
        if ('Yes' === value) {
            return this.translate.instant("claimSection.generalLabels.radioButtonLabels.yes");
        } else {
            if ('No' === value) {
                return this.translate.instant("claimSection.generalLabels.radioButtonLabels.no");
            }
        }
        return '';
    }

    getDate(dt: Date) {
        if (dt && dt != null) {
            return new DatePipe('en-US').transform(dt, "dd/MM/yyyy");
        }
        else {
            return "";
        }
    }

}
